export default __webpack_public_path__ + "static/media/secure.6b949412.svg";